import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { DELIVERY_LIST_URL } from '../../utils/urls';
import instance from '../../services/services';

function AddressSelectPopup({ isPopup, setIsPopup, onConfirm, onCancel, deliveryData }){
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);
  const [deliveryList, setDeliveryList] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);

  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  
  // 배송지 리스트
  useEffect(() => {
    if(isPopup){
    const fetchDeliveryList = async () => {
      try {
        const response = await instance.post(DELIVERY_LIST_URL);
        setDeliveryList(response.data.data);
      } catch (error) {
        console.error('배송지 리스트 가져오기 실패:', error);
      }
    };
    fetchDeliveryList();
  }
  }, [isPopup]);

  // 배송지 리스트 로딩 시 기본 배송지 자동 선택
  useEffect(() => {
    if (deliveryList.length > 0) {
      const defaultAddress = deliveryList.find(item => item.default_flag === 'Y');
      if (defaultAddress) {
        setSelectedAddress(defaultAddress);
      }
    }
  }, [deliveryList]);

  const handleAddressSelect = (address) => {
    setSelectedAddress(address);
  };

  const handleConfirm = () => {
    if (selectedAddress) {
      // 선택된 주소 데이터를 부모 컴포넌트로 전달
      onConfirm(selectedAddress);
      setIsPopup(false);
    } else {
      alert('배송지를 선택해주세요.');
    }
  };

  const handleClose = (e) => {
    e.preventDefault();
    setIsPopup(false);  // 팝업만 닫기
  };

  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };
  

  if (isPopup)
    return (
        <div 
          className="popup-box-component"
          onClick={handleBackgroundClick}
        >
          <div className={`box content ${popupActive ? 'active' : ''}`}>
            <div className="popup_container">
              <h4 className="pop_title line">배송지 선택</h4>
              <div className="close_btn_con">
                <button 
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>
              <div className="pop_addr_con">
                <ul className="default_info_list address_list ">
                  {/* 기본 뱃지 있는 주소 */}
                  {deliveryList.map((item, index) => (
                  <li className="info_item" key={index}>
                    <div className="info_detail default_radio mx-0 top">
                      <input
                        type="radio"
                        id={`address_${item.mde_seq}`}
                        name="delivery_address"
                        checked={selectedAddress?.mde_seq === item.mde_seq}
                        onChange={() => handleAddressSelect(item)}
                      />
                      <label htmlFor={`address_${item.mde_seq}`}></label>
                    </div>
                    <div className="delivery_info">
                      <div className="info_detail flex1">
                        <div className="delivery_detail">
                          <div className="title">
                            {item.default_flag === 'Y' && (
                            <span className="badge g-100 sm">기본</span>
                            )}
                            <span className="addr_name">{item.mde_title}</span>
                            <span className="addr_name">({item.recipient_name})</span>
                          </div>
                          <div className="info">
                            <p>
                              [{item.recipient_zipcode}]
                              {item.recipient_address_street}
                              ({item.recipient_address_detail})
                            </p>
                            <p>{item.recipient_phone}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  ))}
                
                </ul>
              </div>

              <div className='pop_btn_wrap'>
                <button 
                  type="button"
                  className="default_btn black pop_con_btn" 
                  onClick={handleConfirm}
                >
                  선택
                </button>
              </div>

            </div>
          </div>
        </div>
    );
};

export default AddressSelectPopup;